import React, { useState, useEffect } from 'react';
import API from '../../api/axios';
import { formatCreatedAt } from '../../utils/dateUtils';

const AdminTransactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, totalPages: 1 });
  const [statusFilter, setStatusFilter] = useState('');

  const fetchTransactions = async (page = 1) => {
    setLoading(true);
    try {
      const params = { page, limit: 15 };
      if (statusFilter) params.status = statusFilter;
      const res = await API.get('/admin/transactions', { params });
      setTransactions(res.data.data.transactions);
      setPagination({ page: res.data.data.pagination.page, totalPages: res.data.data.pagination.totalPages });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [statusFilter]);

  const getStatusBadge = (status) => {
    const map = { pending: 'En attente', success: 'Réussi', failed: 'Échoué' };
    return <span className={`badge badge-${status}`}>{map[status] || status}</span>;
  };

  const typeLabels = {
    payment_initiation: 'Initiation',
    callback_received: 'Callback',
    status_update: 'Mise à jour',
    refund: 'Remboursement',
  };

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 22, fontWeight: 600 }}>Transactions</h2>
        <p style={{ color: 'var(--gray-500)', fontSize: 14 }}>Détail de toutes les transactions du système</p>
      </div>

      <div className="card" style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', gap: 12 }}>
          <select className="form-select" style={{ width: 160 }} value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="">Tous statuts</option>
            <option value="success">Réussi</option>
            <option value="pending">En attente</option>
            <option value="failed">Échoué</option>
          </select>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <div className="loading-page"><div className="spinner"></div></div>
        ) : transactions.length === 0 ? (
          <div className="empty-state"><h3>Aucune transaction</h3></div>
        ) : (
          <>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>ID Transaction</th>
                    <th>Type</th>
                    <th>Référence paiement</th>
                    <th>Patient</th>
                    <th>Montant</th>
                    <th>Fournisseur</th>
                    <th>Statut</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((t) => (
                    <tr key={t.id}>
                      <td style={{ fontWeight: 600, fontSize: 12, fontFamily: 'monospace' }}>{t.transaction_id}</td>
                      <td><span className="badge badge-initiated">{typeLabels[t.type] || t.type}</span></td>
                      <td style={{ fontSize: 13 }}>{t.payment?.payment_reference || '-'}</td>
                      <td>{t.payment?.patient ? `${t.payment.patient.first_name} ${t.payment.patient.last_name}` : '-'}</td>
                      <td style={{ fontWeight: 600 }}>{parseFloat(t.amount).toLocaleString()} {t.currency}</td>
                      <td>{t.provider}</td>
                      <td>{getStatusBadge(t.status)}</td>
                      <td>{formatCreatedAt(t)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {pagination.totalPages > 1 && (
              <div className="pagination">
                <button disabled={pagination.page <= 1} onClick={() => fetchTransactions(pagination.page - 1)}>Précédent</button>
                <span style={{ fontSize: 14, color: 'var(--gray-600)' }}>Page {pagination.page} / {pagination.totalPages}</span>
                <button disabled={pagination.page >= pagination.totalPages} onClick={() => fetchTransactions(pagination.page + 1)}>Suivant</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AdminTransactions;
